import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { Radio } from 'src/design/atoms/Radio';
import { Textarea } from 'src/design/atoms/Textarea';
import React from 'react';

interface QuestionBoxProps {
  question: any;
  onValueChange: (id: number, val: string) => void;
  onNoteChange: (id: number, val: string) => void;
  disabled?: boolean;
}

export const QuestionBox: React.FC<QuestionBoxProps> = ({
  question,
  onValueChange,
  onNoteChange,
  disabled = false,
}) => {
  return (
    <Stack gap="md">
      <Radio.Group
        label={question.question}
        value={question.value}
        onChange={(value) => onValueChange(question.id, value)}
      >
        <Group>
          <Radio value="no" label="No" disabled={disabled} />
          <Radio value="yes" label="Yes" disabled={disabled} />
        </Group>
      </Radio.Group>

      <Textarea
        placeholder={question.value === 'yes' ? 'Enter note...' : ''}
        value={question.note}
        onChange={(e) => onNoteChange(question.id, e.target.value)}
        disabled={disabled || question.value === 'no'}
        autosize
        minRows={3}
      />
    </Stack>
  );
};
